"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var InfoBarMessageWithShowDetailsAction = /** @class */ (function (_super) {
    tslib_1.__extends(InfoBarMessageWithShowDetailsAction, _super);
    function InfoBarMessageWithShowDetailsAction(props) {
        var _this = _super.call(this, props) || this;
        _this.showDetails = function (evt) {
            evt.stopPropagation();
            _this.props.detailContainerGetter().appendChild(_this.props.detailsDom);
            _this.setState({ isShowingDetails: true });
        };
        _this.hideDetails = function (evt) {
            evt.stopPropagation();
            _this.props.detailContainerGetter().removeChild(_this.props.detailsDom);
            _this.setState({ isShowingDetails: false });
        };
        _this.state = { isShowingDetails: false };
        return _this;
    }
    InfoBarMessageWithShowDetailsAction.prototype.render = function () {
        var clickHandler = this.state.isShowingDetails ? this.hideDetails : this.showDetails;
        return (React.createElement("a", { className: this.props.className, onClick: clickHandler }, this.state.isShowingDetails
            ? this.props.hideDetailsText
            : this.props.showDetailsText));
    };
    InfoBarMessageWithShowDetailsAction = tslib_1.__decorate([
        mobx_react_1.observer
    ], InfoBarMessageWithShowDetailsAction);
    return InfoBarMessageWithShowDetailsAction;
}(React.Component));
exports.default = InfoBarMessageWithShowDetailsAction;
//# sourceMappingURL=InfoBarMessageWithShowDetailsAction.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-info-bar/lib/components/InfoBarMessageWithShowDetailsAction.js
// module id = 3109
// module chunks = 3 4 17